import { addMinutes, format, parseISO } from "date-fns";

import { ZoomMeeting } from "~/providers/utils/types/zoomMeetingTypes";

type SessionTimeFields = Pick<
  ZoomMeeting,
  | "scheduled_start_time"
  | "scheduled_end_time"
  | "duration"
  | "actual_start_time"
  | "actual_end_time"
  | "actual_duration"
>;

export const getSessionDisplayTimes = (session: SessionTimeFields) => {
  if (session.actual_start_time) {
    return {
      startTime: session.actual_start_time,
      endTime: session.actual_end_time,
      duration: session.actual_duration ?? session.duration,
    };
  }

  return {
    startTime: session.scheduled_start_time,
    endTime: session.scheduled_end_time,
    duration: session.duration,
  };
};

export const formatSessionDateLabel = (startTime: string) =>
  format(parseISO(startTime), "eee, MMM d, yyyy");

export const formatSessionTimeRange = (
  startTime: string | null,
  endTime: string | null,
  duration: number | null,
) => {
  if (!startTime) return null;

  const start = parseISO(startTime);
  const end = endTime
    ? parseISO(endTime)
    : duration
      ? addMinutes(start, duration)
      : null;
  const startLabel = format(start, "h:mm a");

  if (!end) {
    return startLabel;
  }

  return `${startLabel} – ${format(end, "h:mm a")}`;
};

export const formatSessionDateRange = (
  startTime: string | null,
  endTime: string | null,
  duration: number | null,
) => {
  if (!startTime) return "-";

  const dateLabel = formatSessionDateLabel(startTime);
  const timeLabel = formatSessionTimeRange(startTime, endTime, duration);

  return `${dateLabel} · ${timeLabel}`;
};

export const formatSessionParticipants = (participantNames: string[]) =>
  participantNames.length ? participantNames.join(", ") : "-";
